import { LOGIN } from "./config";

const data = {
  data: {
    userID: "LSSB-EAGLE-CREST",
    usersecret: "Admin@lssb2024",
    requestUrl: "*",
    maxrequest: "0",
  },
};


const requestOptions = {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    //Authorization: `Bearer ${token}`, // Include the token in the Authorization header
    //"x-public": "true", // Custom header for public, if needed
  },
  body: JSON.stringify(data),
};


export const AuthLassra = async () => {

    const response = fetch(LOGIN, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
     
     

   const authData = await response.then((data) => {
    // Login successful
    const resdata = data
    // console.log("authData", resdata);
    // console.log("Logged in successfully", data);
    return resdata;
  });
//    console.log("authData", authData);


    return authData;

};




export const nigerianBanks = [
  "Access Bank",
  "Citibank Nigeria",
  "Ecobank Nigeria",
  "Fidelity Bank",
  "First Bank of Nigeria",
  "First City Monument Bank (FCMB)",
  "Globus Bank",
  "Guaranty Trust Bank (GTBank)",
  "Heritage Bank",
  "Jaiz Bank",
  "Keystone Bank",
  "Mainstreet Bank",
  "Parallex Bank",
  "Polaris Bank",
  "Providus Bank",
  "Stanbic IBTC Bank",
  "Standard Chartered Bank Nigeria",
  "Sterling Bank",
  "SunTrust Bank",
  "Union Bank of Nigeria",
  "United Bank for Africa (UBA)",
  "Unity Bank",
  "Wema Bank",
  "Zenith Bank"
];

